// Garde-fous des effets sonores (services/audio.js), purs.
//  - Les voix monophoniques de Tone.js (coup sourd, claquement, rideau, « ouuuh ») refusent deux départs au même instant ou à rebours (« Start time must be
//    strictly greater than previous start time »). Deux effets rapprochés (la photo qui vide la pellicule, puis le son de défaite) y tombent : l'erreur partait
//    de endLevel avant que l'écran « Batterie vide » ne s'affiche. `createStartClock` rend à chaque départ un instant strictement croissant par voix.
//  - Un effet sonore raté ne doit jamais interrompre la partie : `safely` avale l'erreur.
export const START_GAP = 0.005; // secondes, entre deux départs d'une même voix

/** @param {number} [gap] */
export function createStartClock(gap = START_GAP) {
  const last = new Map();
  /** L'instant de départ à utiliser pour cette voix : `time`, ou juste après son dernier départ s'il est déjà pris. */
  return (voice, time) => {
    const start = Math.max(time, (last.get(voice) ?? -Infinity) + gap);
    last.set(voice, start);
    return start;
  };
}

/** Enveloppe une fonction pour qu'elle ne lève jamais d'erreur (renvoie undefined en cas d'échec). */
export function safely(fn) {
  return (...args) => {
    try {
      return fn(...args);
    } catch {
      return undefined;
    }
  };
}
